import { render, staticRenderFns } from "./Apps.vue?vue&type=template&id=36ae9ead&scoped=true"
import script from "./Apps.vue?vue&type=script&lang=js"
export * from "./Apps.vue?vue&type=script&lang=js"
import style0 from "./Apps.vue?vue&type=style&index=0&id=36ae9ead&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ae9ead",
  null
  
)

export default component.exports